<div>
	<h3>Datos del seguro</h3>
	@for (item of items; track item.title) {
		@if (item.text) {
			<app-resume-item
				[title]="item.title"
				[text]="item.text" />
		}
	}
</div>
